<template>
  <div>
    <stickyNav v-if="enableStickyNav" />

    <section class="enterprise-bg">
      <div class="container shape-container">
        <div class="py-5">
          <div class="col-lg-8 py-5">
            <div class="row pt-5">
              <h3 class="display-3 mt-5">
                Your All-in-One App for Airtime, Data & Bill Payments
              </h3>
              <p class="lead text-dark">
                With TopupCliq, you can recharge airtime, buy data bundles, and
                pay your utility bills, all from one easy-to-use mobile or web
                app. <br />
                Fast. Reliable. Always available.
              </p>
            </div>
            <!-- airtime modal -->
            <airtime-modal />
          </div>
        </div>
      </div>
    </section>

    <section class="pb-5 px-lg-0 px-4">
      <div class="container">
        <div class="row row-grid align-items-center pb-md-5">
          <div class="col-lg-12 text-center">
            <h2 class="display-3 text-dark">Why Use TopupCliq?</h2>
          </div>

          <div class="col-md-6 order-md-2">
            <img src="img/theme/build.png" class="img-fluid rounded shadow-lg floating" />
          </div>

          <div class="col-md-6 order-md-1" data-aos="fade-right" data-aos-easing="ease-out-cubic"
            data-aos-duration="1000">
            <div class="pr-md-5">
              <div class="mb-4">
                <img src="img/icons/common/pen.svg" class="img-fluid" />
              </div>

              <div class="lead">
                <div class="d-flex align-items-center">
                  <badge type="primary" circle class="mr-3" icon="ni ni-check-bold"></badge>
                  <p class="display-4 lead mb-0">
                    All Services in One App - Airtime, data, electricity, cable
                    TV, and more.
                  </p>
                </div>
                <div class="d-flex align-items-center">
                  <badge type="primary" circle class="mr-3" icon="ni ni-check-bold"></badge>
                  <p class="display-4 lead mb-0">
                    Instant & Secure - Every transaction is quick and protected
                  </p>
                </div>
                <div class="d-flex align-items-center">
                  <badge type="primary" circle class="mr-3" icon="ni ni-check-bold"></badge>
                  <p class="display-4 lead mb-0">
                    Convenient Access - Use on the web or download the mobile
                    app
                  </p>
                </div>
                <div class="d-flex align-items-center">
                  <badge type="primary" circle class="mr-3" icon="ni ni-check-bold"></badge>
                  <p class="display-4 lead mb-0">
                    Affordable & Reliable - No hidden charges, no delays - just
                    smooth payments.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- process cards -->
    <section class="pb-5 px-lg-0 px-4">
      <div class="container">
        <div class="text-center justify-content-center">
          <div class="col-lg-12">
            <h2 class="display-3 text-default mb-4">
              3 simple process, in less than 3 minutes
            </h2>
          </div>
        </div>
        <div class="row justify-content-center my-5">
          <div class="col-lg-12">
            <div class="row row-grid" data-aos="fade-up" data-aos-easing="ease-out-cubic" data-aos-duration="1000">
              <!--  Download or Sign In -->
              <div class="col-lg-4 d-flex">
                <card class="border-0 text-center w-100 h-100" shadow body-classes="">
                  <div class="mb-4 d-flex justify-content-center">
                    <i class="ni ni-single-02 display-3 text-primary"></i>
                  </div>

                  <h6 class="text-primary text-uppercase display-4 w-100">
                    Sign up
                  </h6>

                  <p class="description mt-3">
                    Get TopupCliq on mobile or use it directly on the web.
                  </p>
                </card>
              </div>

              <!-- Choose a Service -->
              <div class="col-lg-4 d-flex">
                <card class="border-0 text-center w-100 h-100" shadow body-classes="">
                  <div class="mb-4 d-flex justify-content-center">
                    <i class="ni ni-app display-3 text-primary"></i>
                  </div>

                  <h6 class="text-primary text-uppercase display-4 w-100">
                    Choose a Service
                  </h6>

                  <p class="description mt-3">
                    Airtime, data, or utilities - everything is available in one
                    place.
                  </p>
                </card>
              </div>
              <!-- Pay & Go -->
              <div class="col-lg-4 d-flex">
                <card class="border-0 text-center w-100 h-100" shadow body-classes="">
                  <div class="mb-4 d-flex justify-content-center">
                    <i class="ni ni-credit-card display-3 text-primary"></i>
                  </div>

                  <h6 class="text-primary text-uppercase display-4 w-100">
                    Pay & Go
                  </h6>

                  <p class="description mt-3">
                    Make your payment securely, instantly, and hassle-free.
                  </p>
                </card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="values-section pb-5 pt-lg-0 px-lg-0 px-4">
      <div class="container">
        <div class="container pt-lg">
          <div class="row text-center justify-content-center">
            <div class="col-lg-10">
              <h2 class="display-3 text-dark">Features</h2>
            </div>
          </div>

          <div class="row row-grid mt-5 text-center">
            <!-- Web & Mobile Access -->
            <div class="col-lg-3">
              <div class="mb-4">
                <i class="ni ni-laptop display-4 text-primary"></i>
              </div>

              <h5 class="text-dark mt-3">
                <p class="lead text-dark">Web & Mobile Access</p>
              </h5>

              <p class="mt-3 lead-2">One tap use it wherever you are.</p>
            </div>
            <!-- Multiple Services -->
            <div class="col-lg-3">
              <div class="mb-4">
                <i class="ni ni-app display-4 text-primary"></i>
              </div>

              <h5 class="text-dark mt-3">Multiple Services</h5>

              <p class="mt-3 lead-2">Airtime, data, bills - all covered.</p>
            </div>
            <!-- User-Friendly Design -->
            <div class="col-lg-3">
              <div class="mb-4">
                <i class="ni ni-ruler-pencil display-4 text-primary"></i>
              </div>

              <h5 class="text-dark mt-3">User-Friendly Design</h5>

              <p class="mt-3 lead-2">
                Simple, clean, and built for everyday use
              </p>
            </div>
            <!-- Safe Transactions -->
            <div class="col-lg-3">
              <div class="mb-4">
                <i class="ni ni-credit-card display-4 text-primary"></i>
              </div>

              <h5 class="text-dark mt-3">Safe Transactions</h5>

              <p class="mt-3 lead-2">
                Powered by TopupBox’s secure infrastructure.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="bg-white pt-md-5 my-5 px-lg-0 px-4">
      <div class="container">
        <div class="row row-grid align-items-center">
          <div class="col-md-6 pr-lg-5">
            <img src="img/theme/reseller.jpeg" class="img-fluid rounded shadow-lg floating" />
            <!-- <div class="card bg-code shadow text-white border-0 pt-4 pb-2">
              <highlightjs langauge="js" :code="code" />
            </div> -->
          </div>

          <div class="col-md-6">
            <div class="pl-lg-5">
              <div class="mb-4">
                <img src="img/icons/common/access.svg" class="img-fluid" />
              </div>

              <h3>BECOME A TOPUPCLIQ RESELLER</h3>

              <p class="lead my-2">
                Earn More by Reselling Airtime, Data & Utility Services
              </p>

              <p>
                With TopupBox, you can create your own account, buy services at
                a discount, and resell them to your customers. It’s a simple way
                to build income - whether as a side hustle or a full business.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import StickyNav from "../../layout/StickyHeader.vue";
import AirtimeModal from "../components/TopupBox/AirtimeModal.vue";
export default {
  name: "individual",
  components: { StickyNav, AirtimeModal },
  data() {
    return { enableStickyNav: null, code: "" };
  },
  mounted() {
    window.addEventListener("scroll", this.handleNavDisplay);
  },
  destroyed() {
    window.addEventListener("scroll", this.handleNavDisplay);
  },
  methods: {
    handleNavDisplay() {
      var y = window.scrollY;
      if (y > 100 && !this.enableStickyNav) {
        this.enableStickyNav = true;
      } else if (y < 100 && this.enableStickyNav) {
        this.enableStickyNav = false;
      }
    },
  },
};
</script>
